import React, { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context';
import AppShell from '../AppShell/AppShell';

export default function AdminLayout() {
  const { user } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    if (user?.role === 'client') navigate('/client-portal', { replace: true });
  }, [user, navigate]);
  return <AppShell showZohoBanner><Outlet /></AppShell>;
}
